import * as React from 'react';
import { useEffect, useState } from 'react';
import BomListUl from './BomListUl';
import { Drop } from "../../../component/DragAndDrop/Drop";
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import useReduxState from "../../../hooks/useReduxState";
import { useBOMProjectStore } from "../../../hooks/bom_project";

const BomList = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const { bom_listing } = props;
    const [listOfBOM, setListOfBOM] = useState({});
    const [liveTotalCount, setLiveTotalCount] = useState(0);
    const [find_bom_input_bom_listing] = useReduxState({}, 'find_bom_input_bom_listing');
    const [{ total_bom }, { }, { }] = useBOMProjectStore();
    const [liveTotalCountIncludingProjects, setLiveTotalCountIncludingProjects] = useReduxState({}, 'BOM__liveTotalCountIncludingProjects');

    useEffect(() => {
        setListOfBOM(bom_listing);
    }, [bom_listing]);

    /**
     * Author: Trilok Sain
     * Reason: liveTotalCount variable is not reset when we reset find dom input
     */
    useEffect(() => {
        if(find_bom_input_bom_listing < 1){
            setLiveTotalCount(0)
        }
    }, [find_bom_input_bom_listing])

    useEffect(() => {
        let l = { ...liveTotalCountIncludingProjects };
        l['yourBOMNonID'] = liveTotalCount;
        setLiveTotalCountIncludingProjects(l);
    }, [liveTotalCount]);

    const getTotalCount = () => {
        if (find_bom_input_bom_listing) {
            let c = 0;
            Object.entries(liveTotalCountIncludingProjects).map((v) => {
                if (v[1] > 0) {
                    c = c + v[1];
                }
            });
            return c;
        }
        return total_bom;
    };

    return (
        <Drop>
           {!(listOfBOM !== undefined && Object.keys(listOfBOM).length > 0) &&__check(['BOM_PROJECT_API_CALL']).render}
            <div style={{
                visibility: getTotalCount() > 0 ? 'visible' : 'hidden'
            }} className="accordion m-t-30 mb-2 position-relative" id="boms">
                 <div>
                        {__check(['BOM_PROJECT_API_CALL'], {overlay: true}).render}
                </div>
                <div className="accordion-item ">
                    <h2 className="accordion-header mb-2" id="headingOne">
                        <button className="accordion-button" type="button" data-toggle="collapse"
                            data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                            <b className="font-24 m-t-10">Your BOMs</b>
                        </button>
                    </h2>
                    <h3 className="ps-3 font-arial font-bold font-13 mt-0 mb-4">Total
                        Results: {getTotalCount()}</h3>
                    <div id="collapseOne" className="accordion-collapse collapse in" aria-labelledby="headingOne"
                        data-parent="#accordionExample">
                        <div className="accordion-body p-0">
                            {
                                listOfBOM !== undefined && Object.keys(listOfBOM).length > 0 &&
                                <BomListUl liveTotalCountCallBack={(count) => {
                                    setLiveTotalCount(count);
                                }} listOfBOM={listOfBOM} />
                            }
                        </div>
                    </div>
                </div>
            </div>

            <div style={{
                display: getTotalCount() > 0 ? '' : 'none'
            }} className="modal fade" id="bomModal" tabIndex="-1" aria-labelledby="exampleModalLabel"
                aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-730">
                    <div className="modal-content">
                        <div className="modal-header border-0">
                            <button type="button" className="close" data-dismiss="modal">&times;</button>
                            <h3 className="modal-title text-center m-auto my-4" id="exampleModalLabel">Are you sure you
                                want
                                to delete this BOM?</h3>
                        </div>
                        <div className="modal-footer d-flex justify-content-center">
                            <button type="button" className="bs5 btn btn-secondary w120">cancel</button>
                            <button type="button" className="bs5 btn btn-primary  w120">delete bom</button>
                        </div>
                    </div>
                </div>
            </div>
        </Drop>
    );
}

export default BomList;